<template>
    <template-block
        v-if="localModel"
        type="Header"
        @toggle-collapsible="$emit('toggle-collapsible')"
        :open="open"
        @delete="$emit('delete')"
        :locked="value.locked"
        :position="value.position"
        :mode="mode"
        @update:locked="localModel.locked = $event; emitChange();"
        @update:position="localModel.position = $event; emitChange();"
    >
        <div class="block-content-grid">
            <select-with-validation
                v-model="localModel.fontFamily"
                :vid="vid + '.fontFamily'"
                label="Font"
                :reduce="(opt) => opt.id"
                component="ecard-template-fonts-filter"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
            <select-with-validation
                v-model="localModel.fontSize"
                :vid="vid + '.fontSize'"
                label="Textstorlek"
                :reduce="(opt) => opt.id"
                component="font-size-filter"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
            <select-with-validation
                v-model="localModel.lineHeight"
                :vid="vid + '.lineHeight'"
                label="Radhöjd"
                :reduce="(opt) => opt.id"
                component="font-size-filter"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
            <select-with-validation
                v-model="localModel.align"
                :vid="vid + '.align'"
                label="Text-placering"
                :reduce="(opt) => opt.id"
                :options="[
                    { label: 'Vänster', id: 'left' },
                    { label: 'Centrerad', id: 'center' },
                    { label: 'Höger', id: 'right' },
                ]"
                :clearable="false"
                @option:selected="emitChange"
            ></select-with-validation>
            <color-picker
                :vid="vid + '.color'"
                label="Textfärg"
                v-model="localModel.color"
                @input="emitChange"
            ></color-picker>
            <color-picker
                :vid="vid + '.linkColor'"
                label="Länkfärg"
                v-model="localModel.linkColor"
                @input="emitChange"
            ></color-picker>
        </div>
    </template-block>
</template>

<script>
import TemplateBlock from '@components/Ecard/TemplateBlock.vue';
import { genUUID } from '@services/Helpers';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import ColorPicker from '@components/Form/ColorPicker.vue';

export default {
    name: 'BlockHeader',
    components: {
        ColorPicker,
        SelectWithValidation,
        TemplateBlock,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        vid: {
            type: String,
            default: 'header.',
        },
        open: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: 'normal',
        },
    },
    data: () => ({
        localModel: null,
    }),
    mounted() {
        this.init(this.value);
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.init(newVal);
            },
        },
        fontSize(newVal) {
            this.localModel.lineHeight = newVal + 4;
            this.emitChange();
        },
    },
    methods: {
        init(newVal) {
            this.localModel = {
                type: 'header',
                id: newVal.id || genUUID(),
                align: newVal.align || 'right',
                color: newVal.color || '#666666',
                linkColor: newVal.linkColor || '#666666',
                fontSize: newVal.fontSize ?? 11,
                lineHeight: newVal.lineHeight ?? 13,
                fontFamily: newVal.fontFamily || 'inherit',
                locked: newVal.locked === undefined || newVal.locked === null ? false : newVal.locked,
            };
        },
        emitChange() {
            this.$emit('input', { ...this.localModel });
        },
    },
};
</script>
